<template>
    <div class="tw-relative">
        <div v-if="states.isLoading" class="tw-flex tw-justify-center">
            <div class="tw-px-10 tw-py-4 tw-font-bold tw-bg-white">
                <div class="tw-h-20">
                    <loading color="green" :active="true" spinner="bar-fade-scale"/>
                </div>
                {{$word.please_wait}}
            </div>
        </div>
        <div v-else>
            <div class="tw-grid tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-6 tw-rounded-lg">
                <div v-for="user in states.people">
                    <a :href="'/'+$window.locale+'/user/' + user.user_name" style="display: block;">
                        <div
                            :style="{ backgroundImage: 'url(' + user.avatar + ')' }"
                            class="grid-avatar-dashboard grid-avatar-dashboard tw-rounded tw-shadow-md tw-border tw-border-solid tw-border-gray-300"
                        >
                            <div class="match-cart-dashboard">
                                <h5 v-if="user.age">{{ user.name }}, {{user.age}}</h5>
                                <h5 v-else>{{ user.name }}</h5>
                                <div class="mb-2">
                                        <i class="fas fa-user"> </i> {{user.user_name}}
                                </div>
                                <div v-if="user.place" class="mb-2">
                                    <i class="fas fa-map-marker-alt"> </i> {{user.place}}
                                </div>
                            
                                <create-chat :user="user"></create-chat>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

            <div v-if="states.people.length === 0">{{$text.did_not_match_any_user}}</div>

            <div class="tw-mt-6 tw-flex tw-justify-center" v-if="!isFullList && states.people.length >= 8">
                <a :href="buildAllMatchesLink()" class="btn text-center dash-all-Matches">{{$word.all_matches}}</a>
            </div>

            <infinite-loading v-if="isFullList" @infinite="ev => store.infiniteHandler(ev)" spinner="waveDots" class="loader">
                <div slot="no-more" class="tw-mt-6 tw-text-2xl tw-text-center">{{$word.no_more}}</div>
                <div slot="no-results" class="tw-mt-6 tw-text-2xl tw-text-center">{{$word.no_more}}</div>
            </infinite-loading>
        </div>
    </div>
</template>
<script>
    import store from "./match-seeker-store";

    export default {
        props: {
            isFullList: {
                default: false,
            },
        },
        created() {
            this.store = store
            this.states = store.states
            this.filters = store.states.filters
        },
        methods: {
            buildAllMatchesLink() {
                return `/${window.locale}/dashboard/matches`;
            },
        }
    }
</script>
